import emUtils from "@/utils/emUtils";

export function customVuexVoPatternFactory({
                                               store: {state, actions, mutations}
                                               , param: {
        voState = "emCustomVuexVo"
    }
                                           } = {}) {

    //转换首字母大写
    let voStateCapFirst = emUtils.toCapFirst(voState)
    //添加state
    Object.assign(state, {
        [voState]: []
        , [`newRows${voStateCapFirst}`]: []
        , [`checkedItems${voStateCapFirst}`]: []
        , [`showNoResultAlert${voStateCapFirst}`]: false
        , [`editingRows${voStateCapFirst}`]: []
    })
    //添加mutations
    Object.assign(mutations, {
        //整体设置
        [`set${voStateCapFirst}`](state, data) {
            state[voState] = data
        },
        //设置属性
        [`set${voStateCapFirst}Attribute`](state, parameters) {
            state[voState][parameters.key] = parameters.newValue;
        },
        //初始化
        [`clear${voStateCapFirst}`](state) {
            state[voState] = []
        },
        [`addNewRow${voStateCapFirst}`](state, row) {
            if (!state[`newRows${voStateCapFirst}`].some(r => r === row)) {
                state[`newRows${voStateCapFirst}`].push(JSON.parse(JSON.stringify(Object.assign(row, state.entityHolder))));
            }
        },
        [`setNewRow${voStateCapFirst}`](state, parameters) {
            let stateRow = state[`newRows${voStateCapFirst}`].filter(r => r === parameters['row'])[0]
            stateRow[parameters.key] = parameters.newValue
        },
        [`setNewRows${voStateCapFirst}`](state, parameters) {
            let stateRow = state[`newRows${voState}`].filter(r => r === parameters['row'])[0]
            stateRow[parameters.key] = parameters.newValue
        },
        [`setCheckedItems${voStateCapFirst}`](state, data) {
            state[`checkedItems${voStateCapFirst}`] = data
        },
        [`setShowNoResultAlert${voStateCapFirst}`](state, data) {
            state[`showNoResultAlert${voStateCapFirst}`] = data
        },
        [`addEditingRow${voStateCapFirst}`](state, row) {
            if (!state[`editingRows${voStateCapFirst}`].some(r => r === row)) {
                // 使用 clone 的结果，这样取消后不影响原始数据
                state[`editingRows${voStateCapFirst}`].push({...row});
            }
        },
        [`clearEditingRows${voStateCapFirst}`](state) {
            state[`editingRows${voStateCapFirst}`] = []
        },
        [`removeEditingRow${voStateCapFirst}`](state, row) {
            state[`editingRows${voStateCapFirst}`] = state[`editingRows${voStateCapFirst}`].filter(r => r.id !== row.id);
        },
        [`removeNewRow${voStateCapFirst}`](state, row) {
            state[`newRows${voStateCapFirst}`] = state[`newRows${voStateCapFirst}`].filter(r => r !== row);
        },
        [`setRow${voStateCapFirst}`](state, parameters) {
            let {row, key, newValue} = parameters;
            let stateRow = state[`editingRows${voStateCapFirst}`].filter(r => r.id === row.id)[0]
            stateRow[key] = newValue
        },
    })
    //添加actions
    Object.assign(actions, {
        //载入
        [`load${voStateCapFirst}`](context, data) {
            context.commit(`set${voStateCapFirst}`, data)
        }
    })

}